import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

// For now, we'll just have English. You can add other languages later.
const resources = {
  en: {
    translation: {
      noAudioSlide: "This slide intentionally has no audio.",
      evalPromoVideoLabel: "This video explains why your evaluations are important to us.",
    },
  },
  "es-419": {
    // Spanish (Latin America) translations
    translation: {
      noAudioSlide: "Esta diapositiva intencionalmente no tiene audio.",
    },
  },
  ja: {
    // Japanese translations
    translation: {
      noAudioSlide: "このスライドには意図的に音声はありません。",
    },
  },
  "pt-BR": {
    // Portuguese (Brazil) translations
    translation: {
      noAudioSlide: "Este slide não tem áudio intencionalmente.",
    },
  },
  "fr-CA": {
    // French (Canada) translations
    translation: {
      noAudioSlide: "Cette diapositive est volontairement sans audio.",
    },
  },
};

i18n
  .use(LanguageDetector) // Detects user language
  .use(initReactI18next) // Passes i18n down to react-i18next
  .init({
    resources,
    fallbackLng: "en", // Use English if detected language is not available
    interpolation: {
      escapeValue: false, // React already safes from xss
    },
  });

export default i18n;
